import { useEffect, useState } from "react";
import styles from "./style.module.scss";

interface LoadingProps {
  isOpen: boolean;
}

export const Loading = ({ isOpen }: LoadingProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return (
    <div className={`${styles.overlay} ${isOpen ? styles.open : ""}`}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <img src="/logo.png" alt="石巻マリンヴィレッジ ロゴ" className={styles.logo} />
        </div>
        <p className={styles.text}>処理中です...</p>
      </div>
    </div>
  );
}; 